import { render, staticRenderFns } from "./CompanyHope.vue?vue&type=template&id=f047d2c4&scoped=true&"
import script from "./CompanyHope.vue?vue&type=script&lang=js&"
export * from "./CompanyHope.vue?vue&type=script&lang=js&"
import style0 from "./CompanyHope.vue?vue&type=style&index=0&id=f047d2c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f047d2c4",
  null
  
)

export default component.exports